import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 1rem 2rem;
  flex-wrap: wrap;
  @media only screen and (max-width: 600px) {
    padding: 0.5rem;
  }
  /* justify-content: space-between; */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: scroll;
`;
export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  & > h1 {
    margin: 0;
    color: #123559;
    margin-left: 1rem;
    @media only screen and (max-width: 600px) {
      font-size: 1.25rem;
    }
  }
`;


